import React, { useEffect, useState } from 'react';
import { Grid, Card, Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from 'react-redux';
import { fetchEspecialidades, buscarEspecialidad, modificarEspecialidad, eliminarEspecialidad, agregarEspecialidad } from '../../../actions/abm/abmEspecialidad';
import { ESPECIALIDADES_PERMISOS } from "../../../utils/permisos";
import ModalAbm from '../../compartidos/abms/ModalAbm';
import BuscadorAbm from "../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../compartidos/abms/AccionesGenericoAbm";
import FormEspecialidades from './FormEspecialidades';
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";


const useStyles = makeStyles({
  root: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "1rem"
  }
});

export const EspecialidadesAbmScreen = () => {
  const { items } = useSelector((state) => state.especialidadAbm);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [especialidad, setEspecialidad] = useState(false);
  const [openAlta, setEspecialidadAlta] = useState(false);
  const [question, setQuestion] = useState(false);
  const datos = items.find(item => item.idEspecialidades)
  useEffect(() => {
    dispatch(fetchEspecialidades());
  }, [dispatch]);

  const handleSearch = (textoBuscado) => {
    dispatch(buscarEspecialidad(textoBuscado));
  }
  const handleEspecialidadSelect = (item) => {
    setEspecialidad(item)
    setOpen(true)
  }
  const handleSave = (item) => {
    if (item.idEspecialidades) {
      dispatch(modificarEspecialidad(item, () => setOpen(false)));
    } else {
      dispatch(agregarEspecialidad(item, () => setEspecialidadAlta(false)));
    }

  }
  const handleDelete = () => {
    dispatch(eliminarEspecialidad(datos.idEspecialidades))
    setQuestion(false)
  }
  // const handleQuestion = () => {
  //   setQuestion(true)
  // }
  const handleCloseQuestion = () => {
    setQuestion(false)
  }

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Especialidad" open={openAlta} setOpen={setEspecialidadAlta}>
          <FormEspecialidades especialidad={null} handleSave={handleSave} permisoAlta={ESPECIALIDADES_PERMISOS.ALTA} cerrarModal={() => setEspecialidadAlta(false)} />
        </ModalAbm>
        <ModalAbm title="Modificar Especialidad" open={open} setOpen={setOpen}>
          <FormEspecialidades especialidad={especialidad} handleSave={handleSave} permisoEdit={ESPECIALIDADES_PERMISOS.MODIFICACION} cerrarModal={() => setOpen(false)} />
        </ModalAbm>

        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setEspecialidadAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Especialidad</Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Especialidad" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label: "",
                  customBody: (item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleEspecialidadSelect}
                      //permisoDelete={false}
                      //handleDelete={false}
                    />
                  )
                },
                {
                  label: "Especialidad",
                  id: "descripcionEspecialidades",
                  sort: true
                },
                {
                  label: "Edad Mínima",
                  id: "edadMinima",
                  sort: false
                },
                {
                  label: "Edad Máxima",
                  id: "edadMaxima",
                  sort: false
                },
                {
                  label: "Visible en Mi OSPEDYC",
                  id: "mobile",
                  sort: true,
                  customBody: (item) => (item.mobile ? "Si" : "No")
                }
              ]}
            />
          </Card>
        </Grid>
      </Grid>
      {question && (
            <AlertFinalizadoStepper
              open={question}
              pregunta={"Alerta"}
              dialogText={"¿Seguro desea eliminar esta especialidad?"}
              buttonCancel={"Cancelar"}
              buttonSubmit={"Continuar"}
              handleClose={handleCloseQuestion}
              handleSend={handleDelete}
            />
      )}
    </div>
  );
};
export default EspecialidadesAbmScreen
